import { useMutation } from 'react-query';

import { deleteActivityCodeAliasById as mutationFn } from 'api/endPoints/deleteActivityCodeAliasById';

export const useMutationDeleteAlias = () => {
    return useMutation<any, QueryError, { id: number | undefined }>((id) => mutationFn(id));
};
